import * as React from "react";
import {authorize, IWithRouterProps, withRouter} from "@athena-portal/components";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import FalconFooter from "../../../../../components/navigation/FalconFooter";
import {ButtonLink} from "../../../../../components/navigation/ButtonLink";
import { scrollToTop, setSessionStorage } from "../../../../../CommonFunctions";
import {FalconNavigatorHeader, CLAIM_TYPE_MOTOR, CLAIM_TYPE_BREAKDOWN, CLAIM_TYPE_OTHER, resourcesHelper} from "@falcon/services";
import {AllianzOnlineBadge} from "../../../../../components/AllianzOnlineBadge";

interface IPickAnnualMotorClaimKindPageParams {
    policyNumber: string;
    [key: string]: string | undefined;
}

interface IState {
    link: string,
    claimTypeChecked: string,
}

@authorize
export class PickAnnualMotorClaimKindPagePlain extends React.Component<IWithRouterProps<IPickAnnualMotorClaimKindPageParams>, IState> {
    private pluginTemplates = new PluginTemplates();

    private claimTypes = new Map<string,string>([
        [CLAIM_TYPE_MOTOR,"Windscreen or window claim"],
        [CLAIM_TYPE_BREAKDOWN,"Breakdown claim"],
        [CLAIM_TYPE_OTHER,"All other claims (road traffic accident, theft, misfuelling, stolen or lost keys, etc)"]
    ]);

    private readonly isBritanniaBrand = () => ["bn", "britannia"].includes((resourcesHelper.THEME || "").toLowerCase());

    constructor(props: IWithRouterProps<IPickAnnualMotorClaimKindPageParams>) {
        super(props);

        this.state = {
            link: "",
            claimTypeChecked: "",
        };
    }

    public componentDidMount(): void {
        scrollToTop();
        this.pluginTemplates.setPageTitle("Make a car claim");
    }

    public render() {

        return (
            <React.Fragment>

                <FalconHeader/>
                <div className="plugin claims">
                    <AllianzOnlineBadge/>
                    <FalconNavigatorHeader
                        back={`/dashboard/annualMotor/${this.props.params.policyNumber}`}
                        title={
                            this.isBritanniaBrand()
                                ? {
                                    html: (
                                        <div className="text-group title plugin no-indent-desktop">
                                            <h1 className="m-0">
                                                <span>Make a </span>
                                                <span className="make-claim-highlight">claim</span>
                                            </h1>
                                        </div>
                                    )
                                }
                                : "Make a car claim"
                        }
                    />
                    {this.isBritanniaBrand() && (
                        <div className="banner banner-info">
                            Your claim will be handled by Liverpool Victoria Insurance Company Limited, which is an Allianz Group company
                        </div>
                    )}
                    <div>
                        <div className="page-contents">
                            {this.renderClaimRadioButtons(this.claimTypes)}
                        </div>
                        <div className="px-4 px-md-0 ml-md-19 padding-0">
                            {(this.state.claimTypeChecked === "" || this.state.claimTypeChecked !== CLAIM_TYPE_OTHER || !this.getOtherClaimsExternalEnabled() || this.isBritanniaBrand()) && <ButtonLink to={this.state.link} primary={true} routeState={{prevPath: location.pathname}}
                                            disabled={this.state.link === ""}
                                            className={"float-right-desktop"}> Next </ButtonLink>}
                            {this.state.claimTypeChecked === CLAIM_TYPE_OTHER && this.getOtherClaimsExternalEnabled() && !this.isBritanniaBrand() && <a href={this.state.link} className={"float-right-desktop"}>
                                <button type="button" className={`btn btn-primary btn-next plugin`}> Next </button>
                            </a>}
                        </div>
                    </div>
                    {this.pluginTemplates.renderBackLink("Back", false, `/dashboard/annualMotor/${this.props.params.policyNumber}`)}
                </div>
                <FalconFooter/>

            </React.Fragment>
        );
    }

    private handleOnChangeEvent = (event: any): void => {
        const value = event.currentTarget.value;
        const otherClaimsExternalEnabled: boolean = this.getOtherClaimsExternalEnabled();

        if(this.claimTypes.has(value)) {
            let claimsLink = "";
            if (value === CLAIM_TYPE_OTHER) {
                if (this.isBritanniaBrand()) {
                    claimsLink = `/dashboard/allOtherMotorClaimsPage/${this.props.params.policyNumber}`;
                } else if (otherClaimsExternalEnabled) {
                    claimsLink = `${process.env.REACT_APP_MOTOR_OTHER_CLAIM_URL}?journey=digital&policy=${this.props.params.policyNumber}`;
                } else {
                    claimsLink = `/dashboard/wolfWindscreenOrBreakdownPage/${this.props.params.policyNumber}`;
                }
            } else {
                claimsLink = `/dashboard/wolfWindscreenOrBreakdownPage/${this.props.params.policyNumber}`;
            }

            this.setState({
                claimTypeChecked: value,
                link: claimsLink
            });

            setSessionStorage("claim", value);
        }
    };

    private getOtherClaimsExternalEnabled() {
        return process.env.REACT_APP_MOTOR_OTHER_CLAIM_EXTERNAL_ENABLED ? JSON.parse(process.env.REACT_APP_MOTOR_OTHER_CLAIM_EXTERNAL_ENABLED) : false;
    }

    private renderClaimRadioButtons(claimTypes: Map<string,string>): React.ReactNode{

        const radioButtons: React.ReactNode[] = [];
        claimTypes.forEach((value,key)=>
        radioButtons.push(
            <div key={key} className="custom-control mt-2 ml-2 mb-3">
                <input
                    className={"custom-radiobutton cursor-pointer"}
                    type="radio"
                    name={key + "-claim"}
                    id={key + "-claim"}
                    value={key}
                    checked={this.state.claimTypeChecked === key}
                    onChange={this.handleOnChangeEvent}
                />
                <label id={'claim-type-label'} className="checkbox-label label-bg-transparent"
                       htmlFor={key + "-claim"}>
                    {value}
                </label>
            </div>)
        );
        return (
            <div className="panel margin-top-30 padding-top-10">
                <p className="font-weight-semi-bold">Please choose what type of claim you want to make?</p>
                <div>{radioButtons}</div>
            </div>
        );
    }

}

export const PickAnnualMotorClaimKindPage = withRouter<{}, IPickAnnualMotorClaimKindPageParams>(PickAnnualMotorClaimKindPagePlain)
